/**
 * @todo это скрипты после работы верстальщика, их необходимо удалить,
 * заменив их нормальным функционалом.
 */
$(".product-catalog-slider ._item").hover(function () {
    $(this).toggleClass("active");
});

$("a.go").click(function (e) {
    e.preventDefault();
    elementClick = $(this).attr("href");
    destination = $(elementClick).offset().top;
    $("body,html").animate({ scrollTop: destination }, 800);
});
